// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Q8nh2","body2":"styles_body2__4N9XG","seperator":"styles_seperator__PTq8M","approved":"styles_approved__4C73n","rejected":"styles_rejected__3stLP"};